module.exports = __webpack_public_path__ + "static/media/appy_logo.d9c652ff.svg";